<template>
  <tr class="tr-items">
    <td :colspan="colspan">
      <div class="tr-items-title">{{ title }}</div>
      <div class="loading loading-lg tr-origin-loading" v-if="loading"></div>
      <div class="tr-origin-empty" v-else-if="items.length === 0">
        <fa-icon class="tr-origin-empty-icon" :icon="['fal', 'info-circle']"/>
        Nenhum item encontrado neste repasse.
      </div>
      <div class="tr-items-wrap" v-else>
        <table class="table">
          <thead>
            <tr>
              <th style="width: 22px"></th>
              <th>{{ referenceLabel }}</th>
              <th>Paciente</th>
              <th>Serviço</th>
              <th>Data</th>
              <th class="text-right">Base</th>
              <th class="text-right">Regra</th>
              <th class="text-right">Repasse</th>
              <th class="text-right">Glosa</th>
              <th class="text-right">Recup.</th>
              <th class="text-right">Líquido</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in items">
              <tr class="tr-row" :key="rowKey(row)"
                  :class="{'calc-open': openKey === rowKey(row), expanded: openKey === rowKey(row)}"
                  @click="toggle(row)">
                <td><fa-icon class="tr-chevron" :icon="['fal', 'chevron-right']"/></td>
                <td class="tr-num">
                  {{ reference(row) }}
                  <span class="tr-sub" v-if="row.role === 'requester'">solicitante</span>
                </td>
                <td class="tr-name">{{ row.patient ? row.patient.name : '—' }}</td>
                <td>
                  <template v-if="row.expense && row.expense.code">
                    {{ row.expense.code }} ·
                  </template>
                  {{ row.expense ? row.expense.name : '—' }}
                </td>
                <td class="tr-num">{{ row.date | date('DD/MM/YY') }}</td>
                <td class="text-right tr-num">{{ row.base | currency }}</td>
                <td class="text-right tr-num">{{ ruleLabel(row.rule) }}</td>
                <td class="text-right tr-num">{{ row.transfer | currency }}</td>
                <td class="text-right tr-num"
                    :class="row.glossed > 0 ? 'text-error' : 'text-muted'">
                  {{ row.glossed > 0 ? signedCurrency(-row.glossed) : '—' }}
                </td>
                <td class="text-right tr-num"
                    :class="row.recovered > 0 ? 'text-green' : 'text-muted'">
                  {{ row.recovered > 0 ? signedCurrency(row.recovered) : '—' }}
                </td>
                <td class="text-right tr-num text-bold">{{ row.net | currency }}</td>
              </tr>
              <tr class="tr-calc-wrap" :key="`${rowKey(row)}-calc`" v-if="openKey === rowKey(row)">
                <td colspan="11">
                  <calc-detail :item="row"/>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </td>
  </tr>
</template>

<script>
import CalcDetail from './CalcDetail.vue';
import { ruleLabel, signedCurrency } from '../helpers';

export default {
  components: {
    CalcDetail,
  },
  props: {
    bundleId: {
      type: String,
      required: true,
    },
    colspan: {
      type: Number,
      default: 9,
    },
    title: {
      type: String,
      default: 'Itens deste repasse',
    },
  },
  data() {
    return {
      loading: true,
      items: [],
      openKey: null,
    };
  },
  computed: {
    referenceLabel() {
      if (this.items.some(({ origin }) => origin === 'lot')) return 'Guia';
      return 'Origem';
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    ruleLabel,
    signedCurrency,
    rowKey(row) {
      return `${row.origin}:${row.id}:${row.role || ''}`;
    },
    reference(row) {
      if (row.origin === 'lot') return row.guide ? row.guide.number : '—';
      if (row.origin === 'cashRegister') return `Recibo ${row.code || ''}`.trim();
      return 'Laudo';
    },
    toggle(row) {
      const key = this.rowKey(row);
      this.openKey = this.openKey === key ? null : key;
    },
    load() {
      this.loading = true;
      return this.$http.get(`/billing-transfers/${this.bundleId}/items`)
        .then(({ data }) => {
          this.items = data.items || [];
        })
        .catch((e) => {
          this.$toast.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
